import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M105.31 43.93C98.67 38.81 96.52 36.64 93.36 27.17C89.84 16.6 82.43 15.01 82.43 15.01C82.43 9.00001 77.76 10.12 71.12 5.66998C68.11 3.65998 62.35 1.84998 56.59 1.84998C50.83 1.84998 45.07 3.64998 42.06 5.66998C35.42 10.12 30.75 9.01001 30.75 15.01C30.75 15.01 22.99 15.76 19.82 26.18C16.92 35.73 14.51 38.82 7.87002 43.93C1.23002 49.05 -2.45998 63.06 7.87002 68.18C7.87002 68.18 12.05 77.75 22.14 76.19C22.14 76.19 28.54 85.09 38.62 80.42C38.62 80.42 26.81 77.97 27.06 66.85C27.31 55.73 35.67 53.5 38.87 43.27C42.03 33.16 46.65 23.4 56.55 28.22C66.95 23.4 71.16 33.16 74.32 43.27C77.52 53.5 85.88 55.73 86.13 66.85C86.38 77.97 74.57 80.42 74.57 80.42C84.65 85.09 91.05 76.19 91.05 76.19C101.13 77.75 105.32 68.18 105.32 68.18C115.64 63.06 111.95 49.04 105.31 43.93Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M30.0601 15.2701C30.0601 15.2701 36.0601 14.1001 39.7501 20.7701C43.4401 27.4401 45.1601 28.2601 47.1301 28.2601"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M35.89 9.00002C35.89 9.00002 40.83 7.89 42.31 15.67C43.79 23.45 47.23 26.79 48.71 27.02"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M43.0401 25.46C43.0401 25.46 35.8901 26.3899 33.6901 37.9199C31.9801 46.9299 30.4901 50.6099 24.3401 57.4999C18.7201 63.7999 18.2501 76.89 27.8401 80.45"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M39.3501 19.4501C39.3501 19.4501 30.2501 18.7801 26.0701 30.8001C21.8901 42.8101 19.3601 45.4601 14.3101 49.1801C8.48006 53.4701 4.73006 60.6301 9.03006 69.4401"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M84.8801 15.71C84.8801 15.71 77.5101 12.7799 73.8201 19.4499C70.1301 26.1199 67.9201 27.9 65.9501 27.9"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M77.62 9.11007C77.62 9.11007 72.35 7.89007 70.87 15.6701C69.39 23.4501 65.95 26.7901 64.47 27.0201"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M70.13 25.46C70.13 25.46 77.5 26.9399 79.48 37.9199C81.26 47.8499 82.81 51.3199 88.96 57.1099C95.11 62.8999 94.7 76.4499 85.11 80.0099"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M73.8201 19.4501C73.8201 19.4501 82.9201 18.7801 87.1001 30.8001C91.2801 42.8101 94.7301 44.8201 99.8901 48.3801C105.06 51.9401 108.85 60.7701 104.91 68.5601"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
